module.exports = __webpack_public_path__ + "static/img/homeBanner1.557adf9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/homeBanner1.png
// module id = foGk
// module chunks = 3